import React from 'react';
import { Flex, Text, Icon, rem } from 'affiny-ui/src';
import { useTranslation } from 'react-i18next';

interface ICompatibilityReportChapterNavigation {
  goToNextChapter?: () => void;
  textNextChapter?: string;
  goToPreviousChapter?: () => void;
  textPreviousChapter?: string;
}

export const CompatibilityReportChapterNavigation = ({
  goToNextChapter,
  textNextChapter,
  goToPreviousChapter,
  textPreviousChapter,
}: ICompatibilityReportChapterNavigation) => {
  const { t } = useTranslation();

  const showNavNextChapter = goToNextChapter && textNextChapter;
  const showNavPreviousChapter = goToPreviousChapter && textPreviousChapter;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      mt={rem(64)}
      mb="xLarge"
    >
      {showNavPreviousChapter && (
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          cursor="pointer"
          onClick={goToPreviousChapter}
        >
          <Icon
            name="arrow-left"
            fontWeight={600}
            size={rem(10)}
            color="accent"
            mr={rem(4)}
            mt={rem(2)}
          />
          <Text fontSize="size16" color="accent" fontWeight={600}>
            {t('compatibilityReport.bottomNav.previous')}
            {textPreviousChapter}
          </Text>
        </Flex>
      )}

      {showNavNextChapter && (
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          cursor="pointer"
          onClick={goToNextChapter}
        >
          <Text fontSize="size16" color="accent" fontWeight={600}>
            {t('compatibilityReport.bottomNav.next')}
            {textNextChapter}
          </Text>
          <Icon
            name="arrow-right"
            fontWeight={600}
            size={rem(10)}
            color="accent"
            ml={rem(4)}
            mt={rem(2)}
          />
        </Flex>
      )}
    </Flex>
  );
};
